import { dateFormats } from 'app/constants';
import format from 'date-fns/format';
import {
  MultiTrackExportFormValues,
  MultiTrackExportRequestData,
  SingleTrackExportFormValues,
  SingleTrackExportRequestData,
} from './types';

export const formatSingleTrackExportData = (
  values: SingleTrackExportFormValues,
  connectionGuid?: string
): SingleTrackExportRequestData => {
  const { title, releaseExportDate, ...rest } = values;
  const date = releaseExportDate
    ? format(new Date(releaseExportDate), dateFormats.DATE_PICKER_FOCUSED)
    : undefined;

  return {
    ...rest,
    ...(date ? { releaseExportDate: date } : {}),
    ...(connectionGuid
      ? { accountConnectionGuid: connectionGuid }
      : { isDraft: true }),
  };
};

export const formatMultiTrackExportData = (
  values: MultiTrackExportFormValues,
  connectionGuid?: string
): MultiTrackExportRequestData => {
  const { releaseExportDate, playlist, ...rest } = values;
  const { genre: genreOption, type: typeOption, description } = playlist;

  const date = releaseExportDate
    ? format(new Date(releaseExportDate), dateFormats.DATE_PICKER_FOCUSED)
    : undefined;

  const genre = genreOption?.value as string;
  const type = typeOption?.value as string;

  return {
    ...rest,
    ...(date ? { releaseExportDate: date } : {}),
    ...(genre
      ? { playlist: { type, description, genre } }
      : { playlist: { type, description } }),
    ...(connectionGuid
      ? { accountConnectionGuid: connectionGuid }
      : { isDraft: true }),
  };
};
